module.exports = __webpack_public_path__ + "img/f_03.4cef90c5.png";